export const IS_LOCALHOST = window?.location?.origin?.includes("localhost") || window?.location?.origin?.includes("127.0.0.1");

export const ENTRYPOINT =
	window?.location?.origin?.includes("localhost") || window?.location?.origin?.includes("127.0.0.1") ? "http://127.0.0.1:8000" : window.location.origin + "/gis";
export const WEBSOCKET_URL = IS_LOCALHOST ? "sipr.lvc.sungis.lv" : window.location.host;
export const LAYERPOINT = IS_LOCALHOST ? "https://sipr.lvc.sungis.lv/gis" : window.location.origin + "/gis";
